const UNIT_NAMES = {
  k: "kg", kg: "kg", kilo: "kg", kilos: "kg", kilogram: "kg", kilograms: "kg",
  g: "g", gr: "g", grs: "g", gramos: "g", gram: "g",
  l: "l", lt: "l", litro: "l", litros: "l", liter: "l",
  ml: "ml", cl: "cl", mj: "bundle", manojo: "bundle", manojos: "bundle", bundle: "bundle",
  bj: "tray", bja: "tray", bandeja: "tray", bandejas: "tray", tray: "tray",
  ud: "unit", uds: "unit", unidad: "unit", unidades: "unit", unit: "unit",
  caja: "box", cajas: "box", box: "box", bolsa: "bag", bolsas: "bag", bag: "bag", pack: "pack", packs: "pack",
};
const GENERIC_WORDS = new Set(["de", "del", "la", "las", "el", "los", "en", "por", "xt", "extra"]);

export const normalizeOcrItemText = (value) => String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");

export function nameParts(value) {
  const words = normalizeOcrItemText(value).replace(/([a-z])([0-9])/g, "$1 $2").replace(/([0-9])([a-z])/g, "$1 $2").split(" ");
  return {
    words: [...new Set(words.filter((word) => /[a-z]/.test(word) && word.length >= 2 && !UNIT_NAMES[word] && !GENERIC_WORDS.has(word)))],
    units: [...new Set(words.map((word) => UNIT_NAMES[word]).filter(Boolean))],
    numbers: words.filter((word) => /^\d+$/.test(word)).sort(),
    negative: words.some((word) => ["sin", "no", "without", "sense", "sans", "senza"].includes(word)),
  };
}

export function incompatible(a, b) {
  return (a.numbers.length && b.numbers.length && a.numbers.join("|") !== b.numbers.join("|")) ||
    (a.units.length && b.units.length && !a.units.some((unit) => b.units.includes(unit))) ||
    (a.words.length && b.words.length && a.negative !== b.negative);
}
